export default __webpack_public_path__ + "static/media/ic-mobil-vaksin.550213a8.svg";